import { Calendar, Medal, Trophy } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

import type { BottomBarButtonProps } from '@/types';

function BottomBarButton({
  icon,
  label,
  isActive,
  onClick,
}: BottomBarButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`relative flex flex-col items-center gap-1.5 transition-all duration-300 hover:scale-110 active:scale-105 rounded-xl px-4 py-2 group ${
        isActive
          ? 'text-foreground before:absolute before:inset-0 before:transition-transform before:duration-300'
          : 'text-muted-foreground hover:text-foreground'
      }`}
    >
      <div
        className={`relative transition-transform duration-300 ${
          isActive ? 'scale-110' : ''
        }`}
      >
        {icon}
      </div>
      <span
        className={`text-xs font-medium transition-all duration-300 relative ${
          isActive
            ? 'text-foreground'
            : 'text-muted-foreground group-hover:text-foreground'
        }`}
      >
        {label}
      </span>
    </button>
  );
}

export default function BottomBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath =
    location.pathname === '/' ? 'challenges' : location.pathname.slice(1);

  const showOnly = ['/', '/leaderboard', '/calendar'];

  if (!showOnly.includes(location.pathname)) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 w-full bg-background/90 backdrop-blur border-t border-border/50 px-4 py-2 pb-[25px] bottom-bar-container">
      <div className="flex justify-between items-center max-w-screen-xl mx-auto bottom-bar-content">
        <BottomBarButton
          icon={
            <Trophy
              className={`h-5 w-5 transition-all duration-300 ${
                currentPath === 'challenges'
                  ? 'text-foreground'
                  : 'text-muted-foreground group-hover:text-foreground'
              }`}
            />
          }
          label="Challenges"
          isActive={currentPath === 'challenges'}
          onClick={() => navigate('/')}
        />
        <BottomBarButton
          icon={
            <Medal
              className={`h-5 w-5 transition-all duration-300 ${
                currentPath === 'leaderboard'
                  ? 'text-foreground'
                  : 'text-muted-foreground group-hover:text-foreground'
              }`}
            />
          }
          label="Leaderboard"
          isActive={currentPath === 'leaderboard'}
          onClick={() => navigate('/leaderboard')}
        />
        <BottomBarButton
          icon={
            <Calendar
              className={`h-5 w-5 transition-all duration-300 ${
                currentPath === 'calendar'
                  ? 'text-foreground'
                  : 'text-muted-foreground group-hover:text-foreground'
              }`}
            />
          }
          label="Calendar"
          isActive={currentPath === 'calendar'}
          onClick={() => navigate('/calendar')}
        />
      </div>
    </div>
  );
}
